export default "__VITE_ASSET__RgNeJ1bN__"